import styled from "@emotion/styled";
import Button from "@/components/Button";
import React from "react";
import { css } from "@emotion/react";

export const SubscribeBoxWrapper = styled.div`
	width: 100%;
	border-radius: 4px;
	padding: 30px 0 30px 30px;
	border: 1px solid #e0e0e0;
	display: flex;
	align-items: flex-start;
`;

export const SubscribeBoxName = styled.p`
	line-height: 24px;
	color: #0d0d0d;
	width: 300px;
	font-weight: bold;
`;

export const SubscribeBoxMainWrapper = styled.div`
	width: 0;
	flex-grow: 1;
	height: 100%;
`;

export const SubscribeContent = styled.div`
	display: flex;
	flex-direction: column;
`;

interface SubscribeTitleWrapperProps {
	disabledBorder?: boolean;
	className?: string;
}

export const SubscribeTitleWrapper = styled(
	({ disabledBorder, ...args }: SubscribeTitleWrapperProps) => <div {...args} />,
)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 34px 30px 0;
	border-bottom: 1px solid #e0e0e0;

	${({ disabledBorder }) =>
		disabledBorder &&
		css`
			border: 0;
			padding-bottom: 0;
		`}
`;

export const SubscribeTitle = styled.p`
	font-size: 40px;
	font-weight: bold;
	flex-grow: 1;
	margin-right: 8px;
`;

export const SubscribeChangeButton = styled(Button)`
	width: 66px;
	height: 34px;
	color: #fff;
`;

export const SubscribeInfoWrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding-right: 34px;
`;

export const SubscribeDateWrapper = styled.div`
	display: flex;
	align-items: center;
	margin: 20px 0;
`;

export const SubscribeDateTitle = styled.p`
	font-size: 14px;
	line-height: 28px;
	margin-right: 46px;
`;

export const SubscribeDateContent = styled.p`
	font-size: 14px;
	line-height: 28px;
	margin-right: 10px;
`;

export const SubscribeDateDeadline = styled.p`
	font-size: 14px;
	line-height: 25px;
	background-color: #ffd9dd;
	color: #bf0712;
	padding: 0 8px;
	border-radius: 4px;
	font-weight: 700;
`;

export const SubscribeDescriptionWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	padding: 24px 20px;
	background-color: #fff4db;
`;

export const SubscribeDescriptionIcon = styled.img`
	width: 18px;
	height: 18px;
	margin: 2px 10px 0 0;
`;

export const SubscribeDescriptionContent = styled.p`
	font-size: 14px;
	line-height: 22px;
	color: #0f0b01;
`;
